// extracted by mini-css-extract-plugin
export default {"FormContainer":"Form_FormContainer__hTNA9","TextBox":"Form_TextBox__Pz4BU","LongText":"Form_LongText__4dNfT"};